"use strict";

var _classCallCheck = require("/var/nobackup/jenkins/jobs/DDI Frontend/branches/release-2022-04.94hkrn/workspace/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/var/nobackup/jenkins/jobs/DDI Frontend/branches/release-2022-04.94hkrn/workspace/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/var/nobackup/jenkins/jobs/DDI Frontend/branches/release-2022-04.94hkrn/workspace/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/var/nobackup/jenkins/jobs/DDI Frontend/branches/release-2022-04.94hkrn/workspace/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/var/nobackup/jenkins/jobs/DDI Frontend/branches/release-2022-04.94hkrn/workspace/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.RectElement = void 0;

var Point2D_1 = require("../../Core/Point2D");

var Rect_1 = require("../../Core/Rect");

var Element_1 = require("./Element");
/**
 * The rect element for selectors
 */


var RectElement = /*#__PURE__*/function (_Element_1$Element) {
  _inherits(RectElement, _Element_1$Element);

  /**
   * Creates the new `RectElement`.
   * @param paper - The `Snap.Paper` object to draw on.
   * @param boundRect - The parent bounding box for selection.
   * @param rect - The rect size.
   */
  function RectElement(paper, boundRect, rect) {
    var _this;

    _classCallCheck(this, RectElement);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(RectElement).call(this, paper, boundRect));
    _this.rect = new Rect_1.Rect(rect.width, rect.height);
    _this.originPoint = new Point2D_1.Point2D(0, 0);

    _this.buildUIElements();

    _this.hide();

    return _this;
  }
  /**
   * The `x`-coordinate of the cross center.
   */


  _createClass(RectElement, [{
    key: "move",

    /**
     * Moves rect element to specified location.
     * @param p - The new rect location.
     */
    value: function move(p) {
      this.node.node.setAttribute("x", p.x.toString());
      this.node.node.setAttribute("y", p.y.toString());
      this.originPoint.move(p);
    }
    /**
     * Resizes the element to specified `width` and `height`.
     * @param width - The new `width`.
     * @param height - The new `height`.
     */

  }, {
    key: "resize",
    value: function resize(width, height) {
      this.rect.resize(width, height);
      this.node.node.setAttribute("height", height.toString());
      this.node.node.setAttribute("width", width.toString());
    }
    /**
     * Builds the visual presentation of the element.
     */

  }, {
    key: "buildUIElements",
    value: function buildUIElements() {
      this.node = this.paper.rect(0, 0, this.rect.width, this.rect.height);
    }
  }, {
    key: "x",
    get: function get() {
      return this.originPoint.x;
    }
    /**
     * The `y`-coordinate of the cross center.
     */

  }, {
    key: "y",
    get: function get() {
      return this.originPoint.y;
    }
  }]);

  return RectElement;
}(Element_1.Element);

exports.RectElement = RectElement;